import { useSelector } from 'react-redux';
import Workspace from 'src/entities/workspace';
import { getWorkspaces } from 'src/selectors/workspaces';

const useWorkspace = ( workspaceID: number ): Workspace | undefined => useSelector(
	state => getWorkspaces( state ).get( workspaceID )
);

export default useWorkspace;
